'use strict';

angular.module('docketbook').
  controller('xeroConnectController', function (userService, xeroService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, accessControl, $timeout, geolocation) {

    $scope.$parent.xeroConnectLogin = function (returnAction) {
      if (returnAction) {
        $scope.returnAction = returnAction;
      } else {
        $scope.returnAction = null;
      }
      $("#xeroConnectModal").fadeIn(100);
      $scope.xeroConnect = { redirecting: false, stage: 'initial' };
    }

    $scope.$parent.xeroConnectConfirm = function (returnAction, returnCallback) {
      $scope.xeroConnect.confirming = false;
      $scope.confirmCallback = returnCallback;
      if (returnAction) {
        $scope.returnAction = returnAction;
      } else {
        $scope.returnAction = null;
      }
      xeroService.getXeroAuthTenants(function (authDetails) {
        if (authDetails && authDetails.length > 0) {
          $("#xeroConnectModal").fadeIn(100);
          $scope.xeroConnect = { redirecting: false, stage: 'confirm', tenantsAvailable: authDetails, tenantSelected: authDetails[0].tenantId };
        } else {
          // show error message
          alert('error getting xero tenants back');
        }
      }, function (err) {
        alert('error getting xero tenants back');
      })

    }

    $scope.$parent.directReauthenticate = function () {
      $scope.xeroConnectAuthorise();
    }

    $scope.closeXeroConnectModal = function () {
      $("#xeroConnectModal").fadeOut(100);
    }

    $scope.xeroConnectAuthorise = function () {
      $scope.xeroConnect.redirecting = true;
      if ($scope.returnAction) {
        window.location.href += "?action=" + $scope.returnAction;
      }
      window.location = DOCKETBOOK_API_URL + "/" + $scope.urlVersion + "/organisations/" + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/xero/auth?source=" + btoa(window.location.hash);
    }

    $scope.xeroConfirmConnection = function () {
      $scope.xeroConnect.confirming = true;
      $scope.xeroEndpoint.one('enablement').customPUT({
        enabled: true,
        tenantSelected: $scope.xeroConnect.tenantSelected
      }).then(function (response) {
        $scope.xeroConnect.confirming = false;
        $scope.closeXeroConnectModal();
        $scope.confirmCallback(response);
      });
    }
  });



// WEBPACK FOOTER //
// ./src/controllers/modals/xeroConnectController.js